import React, { useCallback } from 'react';
import clsx from 'clsx';
import type { SurveyQuestion, OpenTextAnswer } from '@/types/survey';

interface Props {
  question: SurveyQuestion;
  answer: OpenTextAnswer | undefined;
  onChange: (ans: OpenTextAnswer) => void;
}

export const OpenTextQuestion: React.FC<Props> = ({ question, answer, onChange }) => {
  const value = answer?.answer_text ?? '';
  const maxLen = typeof question.max_length === 'number' ? question.max_length : 1000;
  const placeholder = question.placeholder ?? 'Type your answer here...';

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const next = e.target.value.slice(0, maxLen);
      onChange({
        question_id: question.id,
        question_type: 'open_text',
        answer_text: next,
      });
    },
    [question.id, maxLen, onChange]
  );

  return (
    <div className='flex flex-col gap-3'>
      <textarea
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        maxLength={maxLen}
        className={clsx(
          'min-h-[120px] w-full resize-y rounded-12 border border-gray-300 bg-white p-4',
          'font-sans text-[15px] leading-normal text-gray-900 placeholder:text-gray-400 focus:border-brand-500 focus:outline-none'
        )}
      />

      <div className='flex items-center justify-between text-sm text-gray-600'>
        <span>{question.instruction}</span>
        <span>
          {value.length}/{maxLen}
        </span>
      </div>
    </div>
  );
};

export default OpenTextQuestion;
